module.exports = __webpack_public_path__ + "h5/img/hope-title2.fe7068f4.png";